// libraries
import React from "react";

// components
import { SmartHoldsSections } from "../web-settings";

import { DataSources } from "@components/data-sources";

// material-ui
import { Typography } from "@material-ui/core";

// ~-~-~-~-~-~-~-
// Focus Time Settings
// ~-~-~-~-~-~-~-
interface PersonalCalendarSyncSettingsProps {
  user: any;
  org: any;
}

export const PersonalCalendarSyncSettings = (props: PersonalCalendarSyncSettingsProps) => {
  return (
    <div cw-id={`web-settings-${SmartHoldsSections.PersonalCalendarHold}`}>
      <Typography variant="h2" className="cw-mb-4">
        🏠 Personal calendar sync
      </Typography>
      <Typography variant="subtitle1" className="cw-mb-6">
        Personal calendar sync automatically syncs events from your personal Google Calendar account
        to work calendar. Coworkers with access to your calendar will see an event with a title of
        "Busy (via Clockwise)."{" "}
        <a href={"https://getclockwise.com"} target="_blank">
          Learn more
        </a>
        .
      </Typography>
      <Typography variant="h3" className="cw-mb-4">
        Which calendar would you like Clockwise to sync from?
      </Typography>
      <DataSources user={props.user} org={props.org} showType={"personal"} hideHeaderText />
    </div>
  );
};
